const fontFamilyObj = {
	"titleFamily": "Montserrat",
	"bodyFamily": "Open Sans",
	"timerFamily": "Digital"
};

const globalProfiles = {
	'palette': {
		"primaryColor": "#232882",
		"primaryVariantColor": "#572676",
		"secondaryColor": "#FF1E50",
		"secondaryVariantColor": "#FF1E50",
		"grayColor1": "#031A20",
		"grayColor2": "#03313D",
		"grayColor3": "#02395A",
		"grayColor4": "#979eb7",
		"grayColor5": "#d5d9e7",
		"grayColor6": "#f2f3f7",
		"black": "#000000",
		"white": "#FFFFFF",
		"blue": '#42BAFF',
		"red": '#D63228',
		"pink": '#FD1E51',
		"pink2": '#FF5279',
		"yellow": '#FFD452',
		"green": '#36B496'
	}
};

const entityProfiles = []

const skins = {
	fontFamily: fontFamilyObj,
	globalProfiles: globalProfiles,
	entityProfiles: entityProfiles
};

export default skins;
